<cv-save-button [saving]="saving" [isDirty]="isDirtyForm" (saveForm)="onSave()"></cv-save-button>

<div class="datatable-content scrollable-component">
	<cv-multiselect-search
		[label]="
		'Default Acuity Branch Name (The Incoming order will be created on behalf of this client)'
		"
		[placeholder]="'Select a branch'"
		[options]="acuityLenderBranchesList"
		[values]="acuityBranchSelected"
		[optionText]="'title'"
		[optionValue]="'id'"
		[singleSelectMode] = "true"
		(valuesChange)="onBranchSelected($event, 'acuity')"
		[getOptionsFunction]="lenderService.getAcuityLenderBranches"
		*ngIf="optionsReady">
	</cv-multiselect-search>

	<cv-multiselect-search
		[label]="
		'Default Cmp Acuity Branch Name (The Incoming order will be created on behalf of this client)'
		"
		[placeholder]="'Select a branch'"
		[options]="cmpAcuityLenderBranchesList"
		[values]="cmpAcuityBranchSelected"
		[optionText]="'title'"
		[optionValue]="'id'"
		[singleSelectMode] = "true"
		(valuesChange)="onBranchSelected($event, 'cmpacuity')"
		[getOptionsFunction]="lenderService.getCmpAcuityLenderBranches"
		*ngIf="optionsReady">
	</cv-multiselect-search>

	<cv-input
		(controlKeyup)="defaultConfigModel.defaultAppScopeUserCreation = $event.value.trim()"
		[value]="defaultConfigModel.defaultAppScopeUserCreation"
		[label]="
			'Default Appscope User Creation (This username is required to consume the appscope api. Represents who ordered the order. By default is quicken)'
		"
		[type]="'text'"
		[name]="'defaultSettings'"
		[minlength]="1"
		[placeholder]="'appscope user name'"
	></cv-input>

</div>
